/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { Message } from '@paypalcorp/worldready-react';
import { CaptionText } from '@paypalcorp/pp-react';

import { intents } from '../../common/constants';
import { TOPIC_INTENT_OBJECT } from '../../common/propTypes';
import TopicIntentIcons from './TopicIntentIcon';

const TopicIntentsBlobs = function (props) {
  // eslint-disable-next-line react/prop-types
  const { intent, onClickHandler, component, desktopGrid } = props;

  // eslint-disable-next-line react/prop-types
  const refId = intent && intent.ref_id;

  const iconClassnames =
    component === intents.SEARCH ? 'sh_topic_intent__search_blob_icons' : 'sh_topic_intent__blob_icons';
  let intentLabelClassnames =
    component === intents.SEARCH ? 'sh_topic_intent__search_blob_label' : 'sh_topic_intent__blob_label';
  intentLabelClassnames = desktopGrid
    ? `${intentLabelClassnames} sh_topic_intent__blob_label_desktop`
    : intentLabelClassnames;

  const intentBlobClassNames = desktopGrid
    ? 'sh_topic_intent__blob sh_topic_intent__blob_desktop'
    : 'sh_topic_intent__blob';

  // Render intent / ocp icons
  const renderIcons = () => {
    return (
      <TopicIntentIcons refId={refId} size="md" className={iconClassnames} dataTestId="sh-topic-intent-blob-icons" />
    );
  };

  const renderTopicIntentblob = () => (
    <button
      className="sh_topic_intent__blob__button"
      data-testid="sh-topic-intent-blob-button"
      onClick={(e) => onClickHandler(e, intent)}
    >
      <div data-testid="sh-topic-intent-blob" className={intentBlobClassNames}>
        {renderIcons()}
        <CaptionText size="md" className={intentLabelClassnames} data-testid="sh-topic-intent-blob-label">
          <Message id={`smarthelp.app.topic.sublabel.${refId}`} />
        </CaptionText>
      </div>
    </button>
  );

  if (!_isEmpty(intent)) {
    return renderTopicIntentblob();
  }

  return null;
};

TopicIntentsBlobs.PropTypes = {
  intent: PropTypes.shape(TOPIC_INTENT_OBJECT).isRequired,
  onClickHandler: PropTypes.func,
  component: PropTypes.string,
  desktopGrid: PropTypes.bool,
};

export default TopicIntentsBlobs;
